module.exports = __webpack_public_path__ + "img/Nagad88 Ladderboard.e65893ae.png";